<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
    <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Toggle Actions Dropdown">
        <span class="fa-solid fa-ellipsis-vertical"></span>
    </button>
    <div class="dropdown-menu" ngbDropdownMenu>
        <button ngbDropdownItem (click)="onEditMachine(machine)">
            <span class="fa-solid fa-pen"></span>
            <span translate>Edit</span>
        </button>
        <button ngbDropdownItem (click)="onEditMachineConfiguration(machine)">
            <span class="fa-solid fa-gear"></span>
            <span translate>Configuration</span>
        </button>
        <button ngbDropdownItem (click)="onListGateways(machine)" [disabled]=userRole.isViewerRole>
            <span class="fa-solid fa-table-list"></span>
            <span translate>List gateways</span>
        </button>
        <button ngbDropdownItem
                [ngClass]="{'text-danger': isAdminOrHigher()}"
                [disabled]="!isAdminOrHigher()"
                (click)="onDeleteMachine(machine)">
        <span class="fa-solid fa-trash"></span>
        <span translate>Delete</span></button>
    </div>
</div>
